module.exports = __webpack_public_path__ + "img/training.83e725ac.jpg";